module.exports = __webpack_public_path__ + "img/en.7080a6c5.png";